import React from "react";
import { FormAntd, PageHeader } from "./Notification.styles";
// eslint-disable-next-line no-unused-vars
import { useEffect, useState } from "react";
import { Form, Col, Row, Select, Button, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { masterSeletedValue } from "../../common/features/masterSlice";

import { useGetAllMasterMutation } from "../../common/services/schools";
import { getAllMaster } from "../../common/features/schoolSlice";

import PermissionChecker from "../../components/PermissionChecker";
import { toast } from "react-toastify";
import axios from "axios";

const Notification = () => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const [form] = Form.useForm();
  // eslint-disable-next-line no-unused-vars
  //   const [formSubmitted, setFormSubmitted] = useState(false);
  const [getMasterDetails, { data: getMaster }] = useGetAllMasterMutation();
  const [filteredStandards, setFilteredStandards] = useState([]);

  const user = useSelector((state) => state.userDetails);
  const data = useSelector((state) => state.getAllMaster);

  useEffect(() => {
    if (user?.school) {
      const schoolById = {
        schoolId: user?.school?._id,
      };
      getMasterDetails(schoolById);
    }
  }, [user]);

  useEffect(() => {
    if (user?.school) {
      form.setFieldsValue({
        school: user.school._id,
      });
    }
    if (user?.school && user?.school?.board.length > 0) {
      form.setFieldsValue({
        board: user.school.board[0]._id,
      });
      handleSelectionChange("school", user.school._id);
      handleSelectionChange(
        "board",
        user.school.board.length > 0 ? user.school.board[0]._id : ""
      );
    }
  }, [user, form]);

  useEffect(() => {
    dispatch(getAllMaster(getMaster));
  }, [getMaster]);

  const handleSelectionChange = (type, value) => {
    const newSelection = { type, value };
    console.log(newSelection, "newSelection data check");
    dispatch(masterSeletedValue(newSelection));

    if (type === "medium") {
      const filtered = data?.standards?.filter(
        (standard) => standard.medium === value
      );
      setFilteredStandards(filtered);
      // form.setFieldsValue({ standard: undefined }); // Reset standard selection
    }
  };

  const onFinish = async (values) => {
    const notificationData = {
      standardId: values.standard,
      title: values.title,
      description: values.description,
      route: "/home",
      id: Date.now().toString(),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/userservice/api/student/sendNotifications`,
        notificationData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      console.log(response, "response data check");
      toast.success("Notification sent successfully");
      // ✅ Clear only the editable fields (title, description, medium, standard)
      form.resetFields(["medium", "standard", "title", "description"]);
    } catch (error) {
      toast.error("Failed to send notification");
    }
  };

  return (
    <>
      <PageHeader>
        <h2>Notification</h2>
      </PageHeader>
      <FormAntd form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="board"
              label="Board"
              rules={[{ required: true, message: "Please select your board" }]}
            >
              {user?.school && (
                <Select
                  placeholder="Select a board"
                  onChange={(value) => handleSelectionChange("board", value)}
                  value={user.school._id}
                  disabled
                >
                  {user?.school?.board.map((item) => (
                    <Option key={item?._id} value={item?._id}>
                      {item?.boardName}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="school"
              label="School"
              rules={[{ required: true, message: "Please select your school" }]}
            >
              {user?.school && (
                <Select
                  placeholder="Select a School"
                  onChange={(value) => handleSelectionChange("school", value)}
                  value={user.school._id}
                  disabled
                >
                  <Option value={user.school._id} key={user.school._id}>
                    {user.school.schoolName}
                  </Option>
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="medium"
              label="Medium"
              rules={[{ required: true, message: "Please select your medium" }]}
            >
              <Select
                placeholder="Select a Medium"
                onChange={(value) => handleSelectionChange("medium", value)}
              >
                {data?.mediums?.map((item) => (
                  <Option value={item._id} key={item._id}>
                    {item.mediumName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="standard"
              label="Standard"
              rules={[
                { required: true, message: "Please select your standard" },
              ]}
            >
              <Select
                placeholder="Select a Standard"
                onChange={(value) => handleSelectionChange("standard", value)}
              >
                {filteredStandards?.map((item) => (
                  <Option value={item._id} key={item._id}>
                    {item.standardName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please Provide Title" }]}
          initialValue=""
        >
          <Input placeholder="Enter Title" />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please Provide Description" }]}
          initialValue=""
        >
          <Input placeholder="Enter Description" />
        </Form.Item>
        <Form.Item>
          <PermissionChecker resource="notification" action="create">
            <Button
              style={{ backgroundColor: "#1f292b" }}
              type="primary"
              htmlType="submit"
            >
              Send Notification
            </Button>
          </PermissionChecker>
        </Form.Item>
      </FormAntd>
    </>
  );
};

export default Notification;
